import React from 'react';

export const ProductModal = ({ product, onClose }) => {
  if (!product) return null;

  return (
    <div className="pmodal-overlay open" onClick={(e) => { if (e.target.classList.contains("pmodal-overlay")) onClose(); }}>
      <div className="pmodal">
        <button className="pmodal-close" onClick={onClose}>✕</button>

        <img src={product.image} alt={product.name} className="pmodal-img" />

        <div className="store-badge" style={{ color: product.tagColor, background: `${product.tagColor}18` }}>
          <span className="store-badge-dot" style={{ background: product.tagColor }} />
          {product.category}
        </div>

        <div className="pmodal-title">{product.name}</div>
        <div className="pmodal-price">{product.price}</div>

        <div className="pmodal-section">
          <div className="pmodal-section-label">Overview</div>
          <p className="pmodal-text">{product.desc}</p>
        </div>

        {product.features.length > 0 && (
          <div className="pmodal-section">
            <div className="pmodal-section-label">What's included</div>
            <div className="pmodal-features">
              {product.features.map(f => <span key={f} className="pmodal-feature">{f}</span>)}
            </div>
          </div>
        )}

        <a href={`mailto:info@nismaystudios.in?subject=Store%20Enquiry%20–%20${encodeURIComponent(product.name)}&body=Hi%20Mayur%2C%0A%0AI'm%20interested%20in%20${encodeURIComponent(product.name)}.%0A%0A`} className="pmodal-cta">
          Enquire about this product →
        </a>
      </div>
    </div>
  );
};